import { Currency } from 'src/constants/currency';

import { TERMS } from '../../../constants/terms';
import type { Condition } from '../../../hooks/useProductData';
import { getAmountString, humanizePriceRange } from '../../humanization';
import { plur } from '../../plur';

export const getStrahovkaOtKleschaConditions = (item): Condition[] => {
  const conditions = [];
  // срок действия, страховая сумма, стоимость

  // срок действия
  const { time } = item;
  const termValue = `${time} ${plur({ value: time, unit: TERMS.days })}`;
  conditions.push({ value: termValue, description: 'Срок действия', wide: true });

  // страховая сумма
  const { sumRub } = item;
  const sumValue = getAmountString(sumRub, Currency.RUB, false);
  conditions.push({ value: sumValue, description: 'Страховая сумма', wide: true });

  // стоимость
  const { priceChild, priceAdult } = item;

  const priceValue = humanizePriceRange({
    priceRange: {
      from: priceChild,
      to: priceAdult,
    },
    allowZero: false,
  });

  conditions.push({ value: `${priceValue} в год`, description: 'Стоимость', wide: true });

  return conditions;
};
